<template>
  <a-modal width="60%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>选择支行</b>
    </a-divider>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('联行号')" prop="code">
                <a-input v-model="queryParam.code" :maxLength="32" :placeholder="$t('请输入')+$t('联行号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行全名')" prop="name">
                <a-input v-model="queryParam.name" :maxLength="32" :placeholder="$t('请输入')+$t('银行全名')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行简称')" prop="bankAlias">
                <a-input v-model="queryParam.bankAlias" :disabled="getBankCodeDisable()" :maxLength="32" :placeholder="$t('请输入')+$t('银行简称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行名称')" prop="bankName">
                <a-input v-model="queryParam.bankName" :disabled="getBankCodeDisable()"  :maxLength="32" :placeholder="$t('请输入')+$t('银行名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行编码')" prop="bankCode">
                <a-input v-model="queryParam.bankCode" :disabled="getBankCodeDisable()" :maxLength="32" :placeholder="$t('请输入')+$t('银行编码')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('城市名称')" prop="cityName">
                <a-input v-model="queryParam.cityName" :maxLength="32" :placeholder="$t('请输入')+$t('城市名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('省份名称')" prop="cityName">
                <a-select :placeholder="$t('请选择')+$t('省份名称')" style="width: 100%" v-model="queryParam.provinceCode" allowClear>
                  <a-select-option v-for="(item, index) in this.cityList" :value="item.areaId+''"
                                   :key="index">
                    {{ item.areaName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="code"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, type: 'radio', onChange: onSelectChange}"
        :pagination="false"
        :customRow="loadCustomRow"
        :bordered="tableBordered">
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import Editor from "@/components/Editor/Editor";
import { tableMixin } from '@/store/table-mixin'
import {pageBranch} from "@/api/merchant/branch";
import {cityListTree} from "@/api/logistics";
import branch from "@/views/merchant/branch";


export default {
  name: 'RadioBranchSelectForm',
  props: {},
  components: {
    Editor,
    CustomDictTag,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      cityList: [],
      bankAlias: undefined,
      pageSizeOptions: ['1', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      open: false,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        code: undefined,
        name: undefined,
        bankAlias: undefined,
        bankName: undefined,
        bankCode: undefined,
        cityCode: undefined,
        cityName: undefined,
        orderByCode: undefined,
        havaClearingCode: true,
        provinceCode: undefined,
        provinceName: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('联行号'),
          dataIndex: 'code',
          align: 'center'
        },
        {
          title: this.$t('银行全名'),
          dataIndex: 'name',
          align: 'center'
        },
        {
          title: this.$t('银行简称'),
          dataIndex: 'bankAlias',
          align: 'center'
        },
        {
          title: this.$t('银行名称'),
          dataIndex: 'bankName',
          align: 'center'
        },
        {
          title: this.$t('银行编码'),
          dataIndex: 'bankCode',
          align: 'center'
        },
        {
          title: this.$t('城市名称'),
          dataIndex: 'cityName',
          align: 'center'
        },
        {
          title: this.$t('省份名称'),
          dataIndex: 'provinceName',
          align: 'center'
        },
      ]
    };
  },
  filters: {},
  created() {
    this.getCityTree();
    this.getList();
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.resetQueryForm()
    },
    /**
     * @param bankAlias bankCdoe
     * @param records 会先过来的id
     * @param areaId 城市id
     */
    openBranch(bankAlias, records,areaId) {
      if (bankAlias) {
        this.bankAlias = bankAlias;
        this.queryParam.bankAlias = bankAlias
      }
      if (areaId) {
        this.queryParam.cityCode = areaId;
      }
      if (records) {
        this.queryParam.orderByCode = records;
      }
      this.getList()
      if (records) {
        this.selectedRowKeys = [records];
      }
      this.open = true;
    },
    openClearBranch(code) {
      this.bankCode = code
      this.getList()
      this.open = true;
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('branchSelect', this.selectedRows[0])
      this.resetQueryForm()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.resetQueryForm()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    getBankCodeDisable() {
      if (this.bankAlias === null || this.bankAlias === undefined || this.bankAlias === '') {
        return false
      } else {
        return true
      }
    },


    getCityTree() {
      cityListTree().then(response => {
        this.cityList = response.data
      })
    },
    /** 查询明星列表 */
    getList () {
      this.loading = true
      pageBranch(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      });
    },
    resetQueryForm() {
      let havaClearingCode = this.queryParam.havaClearingCode
      this.selectedRowKeys= [];
      this.selectedRows= [];
      this.queryParam = {
        code: undefined,
        name: undefined,
        bankAlias: undefined,
        bankName: undefined,
        cityCode: undefined,
        cityName: undefined,
        havaClearingCode: havaClearingCode,
        provinceCode: undefined,
        provinceName: undefined,
        pageNum: 1,
        pageSize: 10
      };
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.resetQueryForm()
      this.handleQuery();
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    loadCustomRow (record, index) {
      return {
        on: {
          click: () => {
            // 记录为disabled则直接返回，默认为不可选
            if (this.selectedRowKeys.find(e=>e.id===record.id)) {
              return;
            }
            let selectedRowKeys  = [record.id]
            let selectedRows =[record]
            this.onSelectChange(selectedRowKeys, selectedRows)
          }
        }
      }
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
  }
}
</script>
